import { useMemo } from 'react';
import { useController } from 'react-hook-form';
import {
  UniversalSelect,
  UniversalSelectProps,
  Option
} from './UniversalSelect';
import { captureException } from '@sentry/react';

export const UniversalSelectWithRHF: React.FC<
  UniversalSelectProps & { formId: string }
> = props => {
  const { field } = useController({ name: props.formId });
  const value = useMemo(
    () =>
      // This is needed because some attributes can have both formats (array and single) when coming from the server.
      //   Ideally this logic would be moved to the form-helper where the conversion should happen, but it's hard to
      //   determine which fields are affected...
      field.value?.map((value: Option | string) => {
        if (typeof value === 'string') {
          captureException(
            new Error(
              `UniversalSelectWithRHF: value is string, but should be an object. ID: ${props.formId}`
            )
          );
          return { value: value, label: value };
        } else {
          return value;
        }
      }),
    [field.value, props.formId]
  );

  return (
    <UniversalSelect
      {...props}
      value={value}
      onChange={newValue => field.onChange(newValue)}
      disabled={props.disabled}
    />
  );
};
